<template lang="html">
  <div class="tabbar">
    <div v-if="getTarbarAuth.home" class="tabbar-item" @click="goFind('find')">
      <img v-if="getTabIndex === 'find'" src="../assets/images/tabs/home_actived.svg" alt="">
      <img v-else src="../assets/images/tabs/home_normal.svg" alt="">
      <span>首页</span>
    </div>
    <div v-if="getTarbarAuth.dynamic" class="tabbar-item" @click="goBbs('dynamic')">
      <img v-if="(getNewStarCircleCount || getNewTaleCount)" class="point" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/red1.svg"/>
      <img v-if="getTabIndex === 'dynamic'" src="../assets/images/tabs/circle_actived.svg" alt="">
      <img v-else src="../assets/images/tabs/circle_normal.svg" alt="">
      <span>发现</span>
    </div>
    <!-- <div v-if="getTarbarAuth.create"  class="tabbar-item" @click="goCreate('create')">
      <img class="create" src="../assets/images/tabs/plus-new.svg" alt="">
    </div> -->
    <div v-if="getTarbarAuth.create"  class="tabbar-item" @click="goCreate('create')">
      <img class="create" src="../assets/images/tabs/plus-new.svg" alt="">
    </div>
    <!-- <div v-if="getTarbarAuth.refining"  class="tabbar-item" @click="goRefining('refining')">
      <img v-if="getTabIndex === 'refining'" src="../assets/images/tabs/video_actived.svg" alt="">
      <img v-else src="../assets/images/tabs/video_normal.svg" alt="">
      <span>开炼</span>
    </div> -->
    <div class="tabbar-item" @click="goGroupsList('groupsList')">
      <img v-if="getTabIndex === 'groupsList'" src="../assets/images/tabs/circleActive3.png" alt="">
      <img v-else src="../assets/images/tabs/circle3.png" alt="">
      <span>圈子</span>
    </div>
    <div v-if="getTarbarAuth.center" class="tabbar-item" @click="goCenter('center')">
      <img v-if="newMessageCount" class="point" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/red1.svg"/>
      <img v-if="getTabIndex === 'center'" src="../assets/images/tabs/user_actived.svg" alt="">
      <img v-else src="../assets/images/tabs/user_normal.svg" alt="">
      <span>我的</span>
    </div>
  </div>
</template>

<script>
import { isAndroid } from '../utils/utils'
import { safeHeight } from '../utils/config'
import { createNamespacedHelpers } from 'vuex'
import { get } from '../utils/token'
import { get as getRequest } from '../utils/request'
const { mapGetters, mapActions } = createNamespacedHelpers('tabbar')
const { mapActions: mapMessageActions, mapGetters: messageMapGetters } = createNamespacedHelpers('message')
export default {
  data () {
    return {
      isAndroid: isAndroid(),
      safeHeight: safeHeight,
      newMessageCount: 0
    }
  },
  mounted () {
    this.getMessageCount()
  },
  methods: {
    getMessageCount () {
      const user = get('user')
      const promise = getRequest({
        url: `/user/messageCount/${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail: { newMessageCount, newStarcircleCount, newTaleCount } } } = res
        if (Object.is(code, 200)) {
          this.newMessageCount = newMessageCount
          this.updateCount(this.newMessageCount)
          this.updateStarCircleCount(newStarcircleCount)
          this.updateTaleCount(newTaleCount)
        }
      }).catch(() => {
      })
    },
    ...mapMessageActions({
      updateCount: 'updateCount',
      updateStarCircleCount: 'updateStarCircleCount',
      updateTaleCount: 'updateTaleCount'
    }),
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    goFind (tab) {
      this.getMessageCount()
      this.updateTabIndex(tab)
      this.$router.push('/exerland/bbs/find')
    },
    goBbs (tab) {
      this.getMessageCount()
      this.updateTabIndex(tab)
      this.$router.push('/exerland/bbs/dynamic')
    },
    goRefining (refining) {
      this.getMessageCount()
      this.updateTabIndex(refining)
      this.$router.push('/exerland/bbs/refining')
    },
    goGroupsList (groupsList) {
      this.getMessageCount()
      this.updateTabIndex(groupsList)
      this.$router.push('/exerland/bbs/groupsList')
    },
    goCreate (tab) {
      this.getMessageCount()
      // 携带标签跳转思路：获取当前URL地址解析
      // 通过split方法把URL以/作为分割生成数组
      const url = decodeURIComponent(window.location.pathname)
      const urlSplit = url.split('/')
      const urlSplitLength = urlSplit.length
      if (isNaN(+urlSplit[urlSplitLength - 2])) {
        this.$router.push({
          name: 'Create',
          query: {
            visible_range: 'common'
          }
        })
        // 跳转到发布动态页
      } else {
        const id = urlSplit[urlSplitLength - 2]
        const title = urlSplit[urlSplitLength - 1]
        this.$router.push({
          name: 'Create',
          params: {
            id,
            title
          },
          query: {
            visible_range: 'common'
          }
        })
      }
      // this.updateTabIndex(tab)
      // this.$emit('create')
    },
    goLive (tab) {
      this.getMessageCount()
      this.updateTabIndex(tab)
      this.$router.push('/exerland/bbs/liveList')
    },
    goCenter (tab) {
      this.getMessageCount()
      this.updateTabIndex(tab)
      this.$router.push('/exerland/bbs/center')
    }
  },
  computed: {
    ...mapGetters({
      getTabIndex: 'getTabIndex'
    }),
    ...messageMapGetters({
      getNewStarCircleCount: 'getNewStarCircleCount',
      getNewTaleCount: 'getNewTaleCount'
    }),
    getTarbarAuth () {
      return this.$store.getters['tarbarAuth/getAuth']
    }
  }
}
</script>

<style lang="scss" scoped>
 .tabbar {
   position: fixed;
   transform:translateZ(1px);
   z-index: 100;
   bottom: 0;
   left: 0;
   height: 50px;
   width: 100%;
   background:rgba(255,255,255,1);
   box-shadow:0px 0px 0px 0px rgba(229,229,234,1);
   border-top: 1px solid #E2E2E2;
   display: flex;
   justify-content: space-around;
  //  box-sizing: border-box;
   .tabbar-item {
     position: relative;
     box-sizing: border-box;
     height: 50px;
     width: 64px;
     display: flex;
     justify-content: center;
     align-items: center;
     flex-direction: column;
    //  padding: 0 15px;
    .point {
      position: absolute;
      right: 15px;
      top: 3px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
     img {
      // width: 24px;
      height: 24px;
     }
     .create {
      //  width: 13.33vw;
      //  height: calc(13.33vw * 50 / 38);
        width: 64px;
        height: 64px;
        box-shadow:0px 2px 12px 0px rgba(0,0,0,0.1);
        border-radius: 32px;
        display: block;
        position: absolute;
        bottom: 11px;
        left: 0;
     }
     span {
       box-sizing: border-box;
       display: inline-block;
       text-align: center;
       color: #333;
       display: block;
       font-weight: bold;
       height:14px;
      font-size:10px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(0,0,0,1);
      line-height:14px;
     }
   }
 }
</style>
